import http from "@/services/http";
import { defineStore } from "pinia";
import {ref} from 'vue';
import router from '@/router/index.js';

export const useAuth = defineStore('auth', () => {
    const token = ref(localStorage.getItem('token'));
    const user = ref(localStorage.getItem('user'));

    function setToken(tokenValue) {
        localStorage.setItem('token', tokenValue);
        token.value = tokenValue;
    }

    function setUser(userValue) {
        localStorage.setItem('user', userValue);
        user.value = userValue;
    }

    function getBearer() {
        return {headers: { Authorization : "Bearer "+token.value }}
    }

    async function checkAuth(op) {
        try {
            const bearer = getBearer();
            await http.get('/user', bearer);
            return true;
        } catch (error) {
            console.log(error?.response?.data);
            return false;
        }
    }

    function logout() {
        setToken('');
        setUser('');
        router.push({name: 'login'});
    }

    return {token, user, setToken, setUser, checkAuth, getBearer, logout}
})